import {css} from 'emotion'
import { Colors, CardSmall, Link } from './..'

export const UserInformationStyle = (cover, ready) => css({
  '.user-form-edit': {
    margin: '4rem auto',
    maxWidth: 1000,
    padding: '0 20px',
    '&-picture': {
      width: '100%',
      '@media (min-width: 1024px)': {
        width: 240
      },
      '.picture': {
        height: 240,
        background: `url(${cover}) no-repeat center`,
        backgroundSize: 'cover',
        position: 'relative',
        'svg': {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          transition: 'opacity 200ms ease',
          opacity: ready ? 0 : 1,
        },
      }
    },
    '&-information': {
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(100% - 240px)',
        flexBasis: 'calc(100% - 240px)',
        paddingLeft: '4rem',
      },
      '.form-row': {
        margin: '1rem 0',
        '&:first-child':{
          marginTop: 0,
        },
        '.label, .information': {
          ...CardSmall,
          textTransform: 'uppercase',
          color: Colors.mediumGrey,
          fontWeight: 'bold',
        },
        '.information': {
          color: 'black',
          maxWidth: '100%',
          flexBasis: '100%',
          margin: '0.5rem 0',
          '@media (min-width: 1024px)': {
            maxWidth: 'calc(100% - 250px)',
            flexBasis: 'calc(100% - 250px)',
            paddingLeft: '1rem',
          },
        },
        '.label': {
          width: 110,
        },
        '.button': {
          width: '100%',
          '@media (min-width: 1024px)':{
            width: 140,
          },
          'button': {
            margin: 0,
          }
        },
        'input[type="password"]': {
          width: '90%',
          '@media (min-width: 1024px)': {
            fontSize: '1rem',
          },
        },
        'input[type="password"] + label': {
          textTransform: 'none',
          fontSize: '1rem',
        },
        'input[type="password"]:disabled': {
          border: 0,
          background: 'none',
          color: 'black',
          fontSize: '1.2rem',
        },
        '.alert > p': {
          fontWeight: 200,
          fontSize: '0.8rem',
          padding: '0 1rem',
          textAlign: 'center',
        }
      },
      '.pass-row': {
        '.btn-request-pass': {
          alignSelf: 'flex-end',
        }
      },
      '.logout-btn': {
        display: 'block',
        ...Link,
        background: 'black',
        width: '100%',
        height: 60,
        lineHeight: '60px',
        textAlign: 'center',
        margin: '4rem auto',
        '@media (min-width: 1024px)': {
          width: 240,
          margin: '4rem 0px 0px auto',
        } ,
        'svg': {
          fill: 'white',
          marginRight: '1rem',
          verticalAlign: 'middle',
        },
        'span': {
          color: 'white',
        },
        '&:hover': {
          background: Colors.red,
          color: 'white',
        }
      }
    },
    'select': {
      appearance: 'none',
      width: '90%',
      border: 0,
      borderBottom: `1px solid ${Colors.lightGrey}`,
      padding: '1rem 0',
      fontSize: '1rem',
      borderRadius: 0,
      color: Colors.mediumGrey,
      background: 'white',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/user.js